import React, { PropsWithChildren } from "react";
import cn from "classnames";
/**
 * The body component of a section.
 */
/**
 * @deprecated
 */
export const SectionBody: React.FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
  const className = cn("section-body");
  return <div className={className}>{children}</div>;
};
